<template>
  <v-layout row class="list">
    <v-flex grow>
      <slot name="item"></slot>
    </v-flex>
    <v-flex shrink>
      <slot name="info-card"></slot>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: 'List'
}
</script>

<style lang="scss" scoped>

.list{
  padding: 15px;
}

</style>
